import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { DistanceType } from '../../../enums/DistanceType';
import { RecipeOriginType } from '../../../enums/RecipeOriginType';
import { RecipeType } from '../../../enums/RecipeType';

export class LinkCustomerRecipeToProductGroupService extends HttpServiceBase {

  handle = (input: LinkCustomerRecipeToProductGroupServiceInput): Promise<Result<LinkCustomerRecipeToProductGroupServiceOutput> | null> => {
    const promise = this.http.post<Result<LinkCustomerRecipeToProductGroupServiceOutput>, LinkCustomerRecipeToProductGroupServiceInput>(
      `${this.baseUrlSislogApi}/point-of-sale/product-recipe-linking?apiKey=${this.getSislogApiKey()}`,
      input);
    return promise;
  }
}

export class LinkCustomerRecipeToProductGroupServiceInput {
  shopifyOrderId: number;
  recipe: CustomerRecipeLinking;
  groups: RecipeLinkingGroup[];
  canEdit?: boolean | null;
}

export class CustomerRecipeLinking {
  id?: number | null;
  shopifyCustomerId: number;
  description?: string | null;
  name?: string | null;
  pathToFile?: string | null;
  distanceType: DistanceType;
  leftSpherical?: string | null;
  leftCylindrical?: string | null;
  leftAxis?: string | null;
  leftNasoPupillaryDistance?: string | null;
  rightSpherical?: string | null;
  rightCylindrical?: string | null;
  rightAxis?: string | null;
  rightNasoPupillaryDistance?: string | null;
  recipeOriginType?: RecipeOriginType | null;
  recipeType?: RecipeType | null;
  leftEyeHeight?: number | null;
  rightEyeHeight?: number | null;
  diagnostics?: CustomerRecipeLinkingDiagnostic[] | null;
  multifocalInfo?: CustomerRecipeLinkingMultifocalInfo | null;
}

export class CustomerRecipeLinkingMultifocalInfo {
  addField?: string | null;
  actualBridge?: number | null;
  actualEyeWidth?: number | null;
  actualEyeHeight?: number | null;
  actualLargestDiagonal?: number | null;
}

export class CustomerRecipeLinkingDiagnostic {
  distanceType: DistanceType;
  leftSpherical?: string | null;
  leftCylindrical?: string | null;
  leftAxis?: string | null;
  leftNasoPupillaryDistance?: string | null;
  rightSpherical?: string | null;
  rightCylindrical?: string | null;
  rightAxis?: string | null;
  rightNasoPupillaryDistance?: string | null;
}

export class RecipeLinkingGroup {
  id?: number | null;
  frame: RecipeLinkingItem;
  lenses: RecipeLinkingItem;
  pairNumber: number;
}

export class RecipeLinkingItem {
  shopifyId: number;
  SKU: string;
}

export class LinkCustomerRecipeToProductGroupServiceOutput {
  orderRecipeInfo: OrderRecipeInfo;
  message: string;
  allGroupsRegistered: boolean;
}

export class OrderRecipeInfo {
  shopifyOrderId: number;
  canEditRecipe: boolean;
}